const PHONE_CLEAR_CODE_REGEX = /^0+/;


export type MobilePhoneRaw = {
    phoneCode?: number;
    phoneNumber?: string;
}

export class ParsePhoneString {
    #phoneCode: number | null = null;
    #phoneNumber: string | null = null;

    constructor(phoneSting: string) {
        this.parseDbPhoneString(phoneSting);
    }

    public get phoneCode(): number {
        return this.#phoneCode;
    }

    public get phoneNumber(): string {
        return this.#phoneNumber;
    }

    public static generatePhoneStringForDb(phoneCode: string, phoneNumber: string): string | null{
        if (!phoneNumber || !phoneCode) {
            return null;
        }

        return (phoneCode + phoneNumber).padStart(
            phoneNumber.length + 3,
            '0',
        );
    }

    private parseDbPhoneString(phoneSting: string): void {
        if (phoneSting) {
            this.#phoneCode = Number(phoneSting
                .slice(0, 3)
                .replace(PHONE_CLEAR_CODE_REGEX, '')
            );

            this.#phoneNumber = phoneSting.slice(3);
        }
    }
}
